import { render, staticRenderFns } from "./MarketingConsents.vue?vue&type=template&id=6f589899"
import script from "./MarketingConsents.vue?vue&type=script&lang=js"
export * from "./MarketingConsents.vue?vue&type=script&lang=js"
import style0 from "./MarketingConsents.vue?vue&type=style&index=0&id=6f589899&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports